/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const AlertDiamondIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Alert Diamond',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M10,18.79492c-.60107,0-1.1665-.23438-1.59131-.65918L1.86426,11.59082c-.87646-.87695-.87646-2.30469-.00049-3.18164L8.40918,1.86426c.84863-.84961,2.33252-.84961,3.18213,0l6.54443,6.54492c.87646.87695.87646,2.30469.00049,3.18164h-.00049l-6.54492,6.54492c-.42432.4248-.98975.65918-1.59082.65918ZM10,2.70508c-.2002,0-.38867.07812-.52979.21973l-6.54541,6.54492c-.29199.29199-.29199.76855.00049,1.06055l6.54443,6.54492c.2832.2832.77783.2832,1.06006,0l6.54492-6.54492c.29248-.29199.29248-.76855,0-1.06055l-6.54443-6.54492c-.1416-.1416-.33008-.21973-.53027-.21973Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="M9.99936,14.99834c-.23065.00812-.45538-.07378-.62661-.22835-.33033-.36462-.33033-.91993,0-1.28455.16935-.15832.39483-.24279.62664-.23476.23635-.00947.46589.08026.63302.24745.16207.1677.24916.39386.24137.62681.01238.23469-.06959.4646-.2277.63864-.17358.16455-.40786.24959-.64671.23475Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="M10,11.625c-.41406,0-.75-.33594-.75-.75v-5c0-.41406.33594-.75.75-.75s.75.33594.75.75v5c0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
